import { CreateElement } from 'src/vue'
import { Component, Prop } from 'vue-property-decorator'

import { ConfirmModal } from '@src/elements/modal/confirm-modal'
import { Modal } from '@src/elements/modal/modal'
import { Button } from '@src/elements/button/button'
import { Spacer } from '@src/elements/spacer/spacer'
import { TrainingPlanService } from '@src/service/training-plan'
import SessionManager from '@src/lib/session_manager'
import Member from '@src/data/member'
import { HolderType } from '@src/data/workout-data'
import { convertToYYYYMMDD } from '@src/util/date-format'

@Component
export class ReviewPopup extends ConfirmModal {

  @Prop({ required: true })
  private trainingPlanId: number

  @Prop({ required: false })
  private member: Member

  @Prop({ required: false })
  private startDate: string
  private shouldShowEditButton: boolean = false

  private service: TrainingPlanService = new TrainingPlanService()

  constructor () {
    super()
  }

  async mounted () {
    const trainingPlan = await this.service.getTrainingPlan(this.trainingPlanId)
    this.shouldShowEditButton = SessionManager.Instance.isManager() || (!SessionManager.Instance.isManager() && trainingPlan!.holderType === HolderType.MEMBER)
  }
  async goToEditTrainingPlan () {
    let trainingPlan = await this.service.getTrainingPlan(this.trainingPlanId)
    let trainingDays = await this.service.getTrainingPlanDays(this.trainingPlanId)
    trainingPlan!.trainingDays = trainingDays || []
    if (trainingPlan!.holderType === HolderType.MEMBER && this.member) { // individual TP
      // create new individual TP
      this.$store.dispatch('setMemberForActiveTraining', this.member)
      trainingPlan!.id = null
      trainingPlan!.startDate = convertToYYYYMMDD(this.startDate)
      trainingDays!.forEach((day) => day.immutable = false)
    } else { // club TP
      this.$store.dispatch('setMemberForActiveTraining', null)
    }
    this.$store.dispatch('setSelectedTrainingPlan', { trainingPlan })
    this.$router.push(`${SessionManager.Instance.getBaseRoute()}/trainingPlan`)
  }

  render (h: CreateElement) {

    return <Modal id='review-modal' show={this.show} title={this.$t('PAGE.MEMBERS.TRAINING.REVIEW_PLAN.TITLE')} closeCallback={this.closeCallback} cssClass={'popup'}>
      <div class='message'>
        {this.shouldShowEditButton ? this.$t('PAGE.MEMBERS.TRAINING.REVIEW_PLAN.BODY') : this.$t('PAGE.MEMBERS.TRAINING.REVIEW_PLAN.BODY_NO_EDIT')}
        <Spacer />
      </div>

      {this.shouldShowEditButton && <div slot='footer' class='btn-row'>
        {!SessionManager.Instance.isAssistant() && <Button type='elevated' class='navigate-btn no' align='right' label={this.$t('PAGE.CONTENT.TRAINING_PLAN.ACTIONS.EDIT')} click={this.goToEditTrainingPlan} />}
        <Button label={this.$t('CANCEL')} click={this.closeCallback} type='outline' />
      </div>}
    </Modal>
  }
}
